<template>
  <div class="flex flex-col">
    <div v-if="label && leftSide" class="pl-2">{{ label }}</div>
    <div class="flex gap-1">
      <q-radio
        v-for="option in options"
        :key="option.value"
        v-bind="$attrs"
        v-model="value"
        unchecked-icon="panorama_fish_eye"
        checked-icon="task_alt"
        :val="option.value"
        size="md"
        style="font-size: 14px">
        <template #default>
          <span v-if="option.cycle" class="relative -top-1">{{ option.cycle }}</span>
          <span v-if="option.price" class="text-xl sm:text-2xl ml-3 mr-2 font-medium relative -top-0.5">{{
            option.price
          }}</span>
          <span v-if="option.cycleText" class="font-medium relative -top-1">/{{ option.cycleText }}</span>
          <span v-else-if="option.label">{{ option.label }}</span>
        </template>
      </q-radio>
    </div>
    <div v-if="label && rightSide" class="pl-2">{{ label }}</div>
  </div>

  <div v-if="isPresent(errorMessage)" class="mt-3 text-xs text-text-danger-tertiary">
    {{ errorMessage }}
  </div>
</template>
<script setup lang="ts">
import { useField } from 'vee-validate';
import { isPresent } from '@/utils/lang';

interface Option {
  label?: string;
  cycle?: string;
  price?: string;
  cycleText?: string;
  value: string | number;
}

interface Props {
  name: string;
  leftSide?: boolean;
  rightSide?: boolean;
  label?: string;
  options?: Option[];
}

const props = withDefaults(defineProps<Props>(), {
  leftSide: false,
  rightSide: false,
  label: '',
  options: () => [],
});

const { value, errorMessage } = useField<string | number>(props.name);
</script>
